import {
  DatePicker,
  Form,
  Modal,
  Select,
  Table,
  TableColumnsType,
  Input,
  ConfigProvider,
  notification,
} from "antd";
import { Button } from "primereact/button";
import React, { useEffect, useRef, useState } from "react";

import styles from "./Form27TableAddRowDialog.module.css";
import { Col, Row } from "react-bootstrap";
import moment, { Moment } from "moment";
import { GetAllPOCompleted } from "../../../../Services/RedcrossService";
const { Search } = Input;

export type DataSourceType = {
  MemoId: string;
  RequestDate: string;
  CompletedDate: string;
  DocumentNo: string;
  memoForms: { [name: string]: string };
};

export function Form27TableAddRowDialog({
  visible,
  onDismiss,
  onCancel,
  memoIds,
  vendorName,
}: {
  visible: boolean;
  onDismiss: (values: DataSourceType[]) => void;
  onCancel: () => void;
  memoIds?: number[];
  vendorName?: string;
}) {
  const [api, contextHolder] = notification.useNotification();

  const [loading, setLoading] = useState(false);
  const selectedRow = useRef<DataSourceType[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const dataSourceRef = useRef<DataSourceType[]>([]);
  const [dataSource, setDataSource] = useState<DataSourceType[]>([]);
  const [vendors, setVendors] = useState<string[]>([]);
  const [textOnSearch, setTextOnSearch] = useState("");
  const [key, setKey] = useState(0);

  const [filter, setFilter] = useState<{
    rangeDate: { start: Moment | null; end: Moment | null };
    vendor: string | null;
  }>({ rangeDate: { start: null, end: null }, vendor: vendorName ?? null });
  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[]) => {
      setSelectedRowKeys(selectedRowKeys);
    },
    getCheckboxProps: (record: DataSourceType) => ({
      name: record.MemoId,
    }),
  };

  const columns: TableColumnsType<DataSourceType> = [
    {
      title: "ลำดับที่",
      dataIndex: "MemoId",
      key: "MemoId",
      width: "100px",
      align: "center",
      render(_, __, index) {
        return index + 1;
      },
    },
    {
      title: "เลขที่ใบสั่งซื้อ (PO)",
      dataIndex: ["memoForms", "เลขที่ใบสั่งซื้อ"],
      key: "poNo",
      // filters: dataSource.map((e: any) => {
      //   return {
      //     text: e?.memoForms["เลขที่ใบสั่งซื้อ"],
      //     value: e?.memoForms["เลขที่ใบสั่งซื้อ"],
      //   };
      // }),
      // filterSearch: true,
      // onFilter: (value, record) => {
      //   return record.memoForms["เลขที่ใบสั่งซื้อ"] === value;
      // },
    },
    {
      title: "วันที่สั่งซื้อ",
      dataIndex: ["memoForms", "วันที่สั่งซื้อ"],
      key: "poDate",
      render(value) {
        const thaiMonthAbbrevPattern = /[ก-ฮ]+\./;
        const monthMap = {
          'Jan': 'ม.ค.', 'Feb': 'ก.พ.', 'Mar': 'มี.ค.', 'Apr': 'เม.ย.', 
          'May': 'พ.ค.', 'Jun': 'มิ.ย.', 'Jul': 'ก.ค.', 'Aug': 'ส.ค.', 
          'Sep': 'ก.ย.', 'Oct': 'ต.ค.', 'Nov': 'พ.ย.', 'Dec': 'ธ.ค.'
        };
        const monthMap2 = {
          '01': 'ม.ค.', '02': 'ก.พ.', '03': 'มี.ค.', '04': 'เม.ย.', 
          '05': 'พ.ค.', '06': 'มิ.ย.', '07': 'ก.ค.', '08': 'ส.ค.', 
          '09': 'ก.ย.', '10': 'ต.ค.', '11': 'พ.ย.', '12': 'ธ.ค.'
        };

        if (!value) return "";

        // แปลงเดือนอังกฤษเป็นไทย
        for (const [engMonth, thaiMonth] of Object.entries(monthMap)) {
          value = value.replace(engMonth, thaiMonth);
        }

        if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d+\+\d{2}:\d{2}$/.test(value)) {
          debugger;
          const [datePart,] = value.split('T');
          const [year, month, day] = datePart.split('-');
          const correctYear = parseInt(year) + 543; // แปลงปีเป็นปีพุทธศักราช
          const monthThai = monthMap2[month as keyof typeof monthMap2]; // แปลงเดือนเป็นภาษาไทย
          const formattedDate = `${day} ${monthThai} ${correctYear}`;
          return <span title={value}>{formattedDate}</span>;
        }

        let formattedDate;
        // สำหรับรูปแบบที่มี '/'
        if (value.includes('/')) {
          const [day, month, year] = value.split('/');
          const correctYear = parseInt(year) > 2500 ? parseInt(year) : parseInt(year) + 543;
          formattedDate = `${day} ${month} ${correctYear}`;
        }
        // สำหรับรูปแบบที่มีช่องว่าง ' '
        else if (value.includes(' ')) {
          const [day, month, year] = value.split(' ');
          const correctYear = parseInt(year) > 2500 ? parseInt(year) : parseInt(year) + 543;
          formattedDate = `${day} ${month} ${correctYear}`;
        }
        // สำหรับรูปแบบที่มี '-'
        else if (value.includes('-')) {
          const [day, month, year] = value.split('-');
          const correctYear = parseInt(year) > 2500 ? parseInt(year) : parseInt(year) + 543;
          formattedDate = `${day} ${month} ${correctYear}`;
        }

        // รองรับกรณีพบเดือนที่ย่อเป็นภาษาไทยแต่ยังไม่ได้แปลงปี
        if (thaiMonthAbbrevPattern.test(value)) {
          const [day, month, year] = value.split(' ');
          const correctYear = parseInt(year) > 2500 ? parseInt(year) : parseInt(year) + 543;
          formattedDate = `${day} ${month} ${correctYear}`;
        }

        if (formattedDate) {
          return <span title={value}>{formattedDate}</span>;
        }

        return value;
      }
      
    },
    {
      title: "ชื่อผู้ประกอบการ",
      dataIndex: ["memoForms", "ชื่อผู้ค้า"],
      key: "vendorName",
    },
    {
      title: "ยอดเงินที่ตรวจรับ",
      dataIndex: ["SumPO"],
      key: "poSum",
      align: "right",
      render(value) {
        return Number(value).toLocaleString();
      },
    },
  ];

//  function prepareDataSource() {
//     let _dataSource = dataSourceRef.current.filter((item) => {
//       if (item.memoForms["ชื่อผู้ค้า"] != filter.vendor) {
//         return false;
//       }
//       if (filter.rangeDate.start && filter.rangeDate.end) {
//         if (!item.memoForms["วันที่สั่งซื้อ"]) {
//           return false;
//         }
//         const contentDate = new Date(
//           item.memoForms["วันที่สั่งซื้อ"]
//         ).getTime();
//         const start = filter.rangeDate.start.startOf("day").valueOf();
//         const end = filter.rangeDate.end.endOf("day").valueOf();
//         if (contentDate < start || contentDate > end) {
//           return false;
//         }
//       }
//       return true;
//     });
//     setDataSource(_dataSource);
//   }

  function handleOnHide() {
    setSelectedRowKeys(selectedRow.current.map((item) => item.MemoId));
    onCancel && onCancel();
  }
  function handleOnDismiss() {
    sessionStorage.setItem("handleAddRow", "true");
    if (selectedRow.current.length > 0) {
      // TODO: show confirm dialog to dismiss
    }
    const selected = dataSource.filter((item) =>
      selectedRowKeys.includes(item.MemoId)
    );
    selectedRow.current = selected;
    onDismiss && onDismiss(selected);
  }

  // useEffect(() => {
  //   if (visible && dataSourceRef.current.length === 0) {
  //   }
  // }, [visible]);

  const isGetAllPOCompleted = async () => {
    // get PO
    setLoading(true);
    if (filter.rangeDate.start && filter.rangeDate.end) {
      try {
        let bodyJson = {
          startDate: filter.rangeDate.start?.startOf("day"),
          endDate: filter.rangeDate.end?.endOf("day"),
        };

        const data = await GetAllPOCompleted(bodyJson);

        if (data) {
          const groupedData = data.reduce((acc: any, item: any) => {
            const {
              MemoId,
              RequestDate,
              CompletedDate,
              DocumentNo,
              memoForms,
              FillterRequestDate,
              FillterCompleteDate,
              SumPO,
            } = item;
            if (!acc[MemoId]) {
              acc[MemoId] = {
                MemoId,
                RequestDate,
                CompletedDate,
                DocumentNo,
                memoForms: {},
                FillterRequestDate,
                FillterCompleteDate,
                SumPO,
              };
            }
            acc[MemoId].memoForms[memoForms.obj_label] = memoForms.obj_value;
            return acc;
          }, {});

          const transformedData: DataSourceType[] = Object.values(groupedData);
          dataSourceRef.current = transformedData;

          const _vendors = new Set<string>(
            data
              .filter((item: any) => item.memoForms.obj_label === "ชื่อผู้ค้า")
              .map((item: any) => item.memoForms.obj_value)
              .sort()
          );
          setVendors([..._vendors]);

          // const _vendors = [
          //   "บริษัท ออฟฟิศเมท (ไทย) จำกัด",
          //   "บริษัท 1111",
          //   "บริษัท 2222",
          // ];
          // setVendors([..._vendors]);
          setDataSource(dataSourceRef.current);
          filter.vendor = null;
          // prepareDataSource();
          setLoading(false);
        }
      } catch (error) {
        console.log("error", error);
        setLoading(false);
      }
    } else {
      api.warning({
        message: "Require field warning.",
        description: "Please select StartDate and EndDate.",
        duration: 60,
      });
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (visible && dataSourceRef.current.length === 0) {
  //     setLoading(true);
  //     fetch("/api/Redcross/GetAllPOCompleted", { method: "POST" })
  //       .then((response) => response.json())
  //       .then((data) => {
  //         console.log("GetAllPOCompleted", data);
  //         setLoading(false);
  //         const aaaa = data.filter(
  //           (item: any) => item.memoForms.obj_label === "ชื่อผู้ค้า"
  //         );

  //         console.log("aaaa", aaaa);

  //         const groupedData = data.reduce((acc: any, item: any) => {
  //           const {
  //             MemoId,
  //             RequestDate,
  //             CompletedDate,
  //             DocumentNo,
  //             memoForms,
  //             FillterRequestDate,
  //             FillterCompleteDate,
  //             SumPO,
  //           } = item;
  //           if (!acc[MemoId]) {
  //             acc[MemoId] = {
  //               MemoId,
  //               RequestDate,
  //               CompletedDate,
  //               DocumentNo,
  //               memoForms: {},
  //               FillterRequestDate,
  //               FillterCompleteDate,
  //               SumPO,
  //             };
  //           }
  //           acc[MemoId].memoForms[memoForms.obj_label] = memoForms.obj_value;
  //           return acc;
  //         }, {});

  //         const transformedData: DataSourceType[] = Object.values(groupedData);
  //         dataSourceRef.current = transformedData;

  //         const _vendors = new Set<string>(
  //           data
  //             .filter((item: any) => item.memoForms.obj_label === "ชื่อผู้ค้า")
  //             .map((item: any) => item.memoForms.obj_value)
  //             .sort()
  //         );
  //         setVendors([..._vendors]);

  //         prepareDataSource();
  //       })
  //       .finally(() => {
  //         setLoading(false);
  //       });
  //   }
  // }, [visible]);

  // useEffect(() => {
  //   // prepareDataSource();
  //   // GetAllPOCompleted();
  //   if (
  //     vendors !== null &&
  //     filter.rangeDate.start !== null &&
  //     filter.rangeDate.end !== null
  //   ) {
  //     // GetAllPOCompleted();
  //   } else if (vendors == null) {
  //     toggleAlert({
  //       description: `Please select vendors`,
  //       message: `Require field warning.`,
  //       type: "warning",
  //     });
  //     setLoading(false);
  //   } else if (filter.rangeDate.start == null || filter.rangeDate.end == null) {
  //     toggleAlert({
  //       description: `Please select startDate or endDate`,
  //       message: `Require field warning.`,
  //       type: "warning",
  //     });
  //     setLoading(false);
  //   } else {
  //     toggleAlert({
  //       description: `Please select field vendors and date`,
  //       message: `Require field warning.`,
  //       type: "warning",
  //     });
  //     setLoading(false);
  //   }
  // }, [filter]);

  // useEffect(() => {
  //   dataSourceHandle.filter((i) =>
  //     i.memoForms["ชื่อผู้ค้า"]
  //       ?.toLowerCase()
  //       .includes(textOnSearch?.toLowerCase())
  //   );
  // }, [filter.vendor]);

  useEffect(() => {
    filter.vendor = null;
    filter.rangeDate.start = moment().add(-6, "day");
    filter.rangeDate.end = moment();
  }, []);

  useEffect(() => {
    if (memoIds) {
      setSelectedRowKeys(memoIds);
    }
  }, [memoIds]);

  useEffect(() => {
    if (vendorName) {
      setFilter({
        ...filter,
        vendor: vendorName,
      });
    }
  }, [vendorName]);

  // const onSearch = (value: any) => {
  //   console.log("onSearch", value);
  //   setTextOnSearch(value);
  //   setLoading(true);
  // };

  const dataSourceHandle = dataSource.filter((i) =>
    i.memoForms["เลขที่ใบสั่งซื้อ"]
      ?.toLowerCase()
      .includes(textOnSearch?.toLowerCase())
  );

  function prepareDataSource(val: any) {
    let _dataSource = dataSourceRef.current.filter(
      (item) => item.memoForms["ชื่อผู้ค้า"] == val || val == null
    );
    // if (item.memoForms["ชื่อผู้ค้า"] !== filter.vendor) {
    //   return false;
    // }
    // if (filter.rangeDate.start && filter.rangeDate.end) {
    //   if (!item.memoForms["วันที่สั่งซื้อ"]) {
    //     return false;
    //   }
    //   const contentDate = new Date(
    //     item.memoForms["วันที่สั่งซื้อ"]
    //   ).getTime();
    //   const start = filter.rangeDate.start.startOf("day").valueOf();
    //   const end = filter.rangeDate.end.endOf("day").valueOf();
    //   if (contentDate < start || contentDate > end) {
    //     return false;
    //   }
    // }
    //   return true;
    // });
    setDataSource(_dataSource);
  }

  return (
    <>
      {contextHolder}
      <Modal
        visible={visible}
        style={{ borderRadius: "16px", maxWidth: "1200px" }}
        width={"100%"}
        onCancel={handleOnHide}
        closable={false}
        footer={
          <div className={styles.actionButtonContainer}>
            <Button className="p-button-danger" onClick={handleOnHide}>
              ยกเลิก
            </Button>
            &nbsp;
            <Button onClick={handleOnDismiss}>บันทึก</Button>
          </div>
        }
      >
        <h2>ตัวกรองข้อมูล</h2>
        <div className={styles.filterContainer}>
          <Form layout="vertical">
            <Row>
              <Col xs={12} lg={4}>
                <Form.Item
                  label={
                    <div>
                      วันที่
                      <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                    </div>
                  }
                >
                  <DatePicker.RangePicker
                    defaultValue={[moment().add(-6, "day"), moment()]}
                    onChange={(values) => {
                      setFilter({
                        ...filter,
                        rangeDate: {
                          start: values ? values[0] : null,
                          end: values ? values[1] : null,
                        },
                      });
                    }}
                    format={(date) =>
                      moment(date)
                        .format("DD MMM YYYY")
                        .replace(/\d{4}/, (year) =>
                          (parseInt(year) + 543).toString()
                        )
                    }
                    ranges={{
                      Today: [moment().startOf("day"), moment().endOf("day")],
                      "This Month": [
                        moment().startOf("month"),
                        moment().endOf("month"),
                      ],
                      "This Year": [
                        moment().startOf("year"),
                        moment().endOf("year"),
                      ],
                    }}
                    // disabled={selectedRowKeys.length > 0 || loading}
                    disabled={loading}
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={12} lg={8} style={{ alignSelf: "end" }}>
                <Button
                  // className={"pi pi-search"}
                  label={"ค้นหา"}
                  onClick={() => isGetAllPOCompleted()}
                  style={{
                    backgroundColor: "#282f6a",
                    border: "1px solid #282f6a",
                    borderRadius: "6px",
                    boxShadow: "none",
                    height: "32px",
                    padding: "0 30px",
                  }}
                />
              </Col>
            </Row>
            <Row style={{ marginBottom: "20px" }}>
              {!filter.rangeDate.start && !filter.rangeDate.end && (
                <div
                  style={{
                    fontSize: "13px",
                    color: "red",
                  }}
                >
                  กรุณาเลือกวันเริ่มต้นและวันสิ้นสุด!
                </div>
              )}
            </Row>

            <Row style={{ marginBottom: "10px" }}>
              <Col xs={12} lg={6}>
                <Form.Item label="ชื่อผู้ประกอบการ">
                  <Select
                    placeholder="ชื่อผู้ประกอบการ"
                    showSearch
                    options={vendors.map((item) => ({
                      value: item,
                      label: item,
                    }))}
                    // disabled={selectedRowKeys.length > 0 || loading}
                    disabled={loading}
                    onChange={(value) => {
                      console.log("filter", value);
                      setFilter({
                        ...filter,
                        vendor: value,
                      });
                      prepareDataSource(value);
                    }}
                    value={filter.vendor}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col xs={12} lg={6}>
                <Form.Item label="ค้นหาเลขที่ใบสั่งซื้อ (PO)">
                  <div>
                    <Input
                      defaultValue={textOnSearch}
                      placeholder="ค้นหาเลขที่ใบสั่งซื้อ (PO)"
                      // key={textOnSearch + key}
                      // onBlur={(e) => {
                      //   if (!e.target.value) return setTextOnSearch("");
                      //   e.target.value && setTextOnSearch(textOnSearch),
                      //     setKey((prev) => prev + 1);
                      // }}
                      onChange={(e: any) => {
                        console.log(e.target.value);

                        setTextOnSearch(e.target.value);
                      }}
                      // onSearch={(e) => onSearch(e)}
                      // enterButton
                      allowClear
                      style={{ borderRadius: "6px !important" }}
                    />
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
        <div>
          <Table
            loading={loading}
            size="small"
            rowKey={"MemoId"}
            columns={columns}
            dataSource={dataSourceHandle.filter((i) => {
              if (!filter.rangeDate.start && !filter.rangeDate.end) return true;
              return (
                new Date(i.RequestDate) >=
                  new Date(moment(filter.rangeDate.start).toDate()) &&
                new Date(i.RequestDate) <=
                  new Date(moment(filter.rangeDate.end).toDate())
              );
            })}
            pagination={{ pageSize: 10 }}
            rowSelection={{
              type: "checkbox",
              selectedRowKeys: selectedRowKeys,
              defaultSelectedRowKeys: selectedRowKeys,
              ...rowSelection,
            }}
          ></Table>
        </div>
      </Modal>
    </>
  );
}
